import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const plansQueryKey = ['plans'] as const

/** Loads the plans the member can buy, at their live prices. */
export function useListPlans() {
  const api = usePortalApi()
  return useQuery({
    queryKey: plansQueryKey,
    queryFn: async () => dataOrThrow(await api.get('/plans')),
  })
}
